var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{staticClass:"not_found_container",attrs:{"status":"404","title":"頁面錯誤","sub-title":_vm.subTitle}})
}
var staticRenderFns = []

export { render, staticRenderFns }